import { Country } from '@tiendanube/common/src/enums';
import { toStatusType } from 'App/rtk';
import { useGetCountry } from 'domains/Auth/hooks';
import { useGetPlanDebtDataQuery } from '../billingPlansApi';

const COUNTRIES_WITH_DOWNGRADE_ALLOWED = [Country.CL, Country.MX, Country.CO];

export function useShouldScheduleDowngrade() {
  const { data, status, refetch } = useGetPlanDebtDataQuery();
  const country = useGetCountry();
  const hasPaidDaysRemaining =
    !!data?.paidUntilDate && new Date() <= new Date(data.paidUntilDate);
  const shouldScheduleDowngrade =
    hasPaidDaysRemaining && COUNTRIES_WITH_DOWNGRADE_ALLOWED.includes(country);
  return {
    shouldScheduleDowngrade,
    downgradeDate: data?.nextPaymentDate,
    status: toStatusType(status),
    retryLoad: refetch,
  };
}
